import {Map} from "@vis.gl/react-google-maps";

const MapSection = () => {
    return (
        <section className="py-16 px-6 bg-secondary/5">
            <div className="max-w-6xl mx-auto">
                <div className="relative h-96 rounded-xl overflow-hidden shadow-lg">
                    <Map
                        defaultZoom={13}
                        defaultCenter={{lat: -34.9011, lng: -56.1645}}
                        className="w-full h-full"
                    />
                </div>
            </div>
        </section>
    );
};

export default MapSection;

